module.exports = __webpack_public_path__ + "static/media/DEGEN-QUICK.9d992b57.png";